import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import(
      /* webpackChunkName: "home" */ '../pages/HomePage.vue'
    )
  },
  {
    path: '/:productSlurg',
    name: 'Product Instance',
    component: () => import(
      /* webpackChunkName: "product" */ '../pages/ProductInstance.vue'
    )
  },
  {
    path: '/category/:productType',
    name: 'Product Type Group',
    component: () => import(
      /* webpackChunkName: "product-type" */ '../pages/ProductCollection.vue'
    )
  },
  {
    path: '/category/:productType/:productCategory',
    name: 'Product Category Group',
    component: () => import(
      /* webpackChunkName: "product-category" */ '../pages/ProductCollection.vue'
    )
  },
  {
    path: '/collection/:collectionName',
    name: 'Product Collection',
    component: () => import(
      /* webpackChunkName: "product-collection" */ '../pages/ProductCollection.vue'
    )
  },
  {
    path: '/checkout/cart',
    name: 'Checkout Cart',
    component: () => import(
      /* webpackChunkName: "checkout-cart" */ '../pages/CartPage.vue'
    )
  },
  {
    path: '/checkout/order',
    name: 'Checkout Order Info',
    component: () => import(
      /* webpackChunkName: "checkout-order" */ '../pages/CheckoutPage.vue'
    )
  },
  {
    path: '/q/search',
    name: 'Search Results Collection',
    component: () => import(
      /* webpackChunkName: "search-results" */ '../pages/ProductCollection.vue'
    )
  },
  {
    path: '/q/contact',
    name: 'Contact Us',
    component: () => import(
      /* webpackChunkName: "contact-us" */ '../pages/ContactUsPage.vue'
    )
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
